import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { ISSUE_ACTION_TYPE } from '~/api/help-center/types/Issue.types'

import type { MachineContext } from '../Diagnosis.machine.types'

import { getCurrentPageData } from './getCurrentPageData'

export const getExternalUrlFromSelectedIssues = (
  pageData: MachineContext['pageData'],
) => {
  const currentPageData = getCurrentPageData(pageData)

  const currentSelectedIssues = currentPageData?.selectedIssues

  if (isEmpty(currentSelectedIssues)) return null

  if (currentSelectedIssues?.length !== 1) return null

  const selectedIssue = currentSelectedIssues[0]

  if (
    [ISSUE_ACTION_TYPE.externalRedirect, ISSUE_ACTION_TYPE.insurerPortal].some(
      (type) => type === selectedIssue?.action?.type,
    )
  )
    return selectedIssue?.action?.target

  return null
}
